(function () {
    window.KocotAnimations = window.KocotAnimations || {};

    window.KocotAnimations.initGalleryRealization = function () {
        var sections = document.querySelectorAll('.gallery-realization');

        sections.forEach(function (section) {
            if (section.dataset.galleryRealizationInitialized === 'true') {
                return;
            }

            var list = section.querySelector('[data-gallery-realization-list]');
            var progress = section.querySelector('[data-gallery-realization-scroll-value]');
            var prevButton = section.querySelector('[data-gallery-realization-prev]');
            var nextButton = section.querySelector('[data-gallery-realization-next]');
            var items = list ? Array.from(list.children) : [];

            if (!list || !items.length) {
                return;
            }

            section.dataset.galleryRealizationInitialized = 'true';

            function getMaxScroll() {
                return Math.max(list.scrollWidth - list.clientWidth, 0);
            }

            function getCurrentItemIndex() {
                var scrollLeft = list.scrollLeft;
                var closestIndex = 0;
                var closestDistance = Infinity;

                items.forEach(function (item, index) {
                    var distance = Math.abs(item.offsetLeft - scrollLeft);

                    if (distance < closestDistance) {
                        closestIndex = index;
                        closestDistance = distance;
                    }
                });

                return closestIndex;
            }

            function scrollToItem(direction) {
                var currentIndex = getCurrentItemIndex();
                var nextIndex = Math.max(0, Math.min(items.length - 1, currentIndex + direction));
                var nextItem = items[nextIndex];

                if (!nextItem) {
                    return;
                }

                list.scrollTo({
                    left: nextItem.offsetLeft,
                    behavior: 'smooth',
                });
            }

            function updateState() {
                var maxScroll = getMaxScroll();
                var scrollLeft = list.scrollLeft;
                var visibleRatio = list.scrollWidth ? list.clientWidth / list.scrollWidth : 1;
                var thumbWidth = Math.min(Math.max(visibleRatio * 100, 8), 100);
                var scrollRatio = maxScroll ? scrollLeft / maxScroll : 0;
                var thumbOffset = scrollRatio * (100 - thumbWidth);

                if (progress) {
                    progress.style.width = thumbWidth + '%';
                    progress.style.left = thumbOffset + '%';
                }

                if (prevButton) {
                    prevButton.disabled = scrollLeft <= 1;
                }

                if (nextButton) {
                    nextButton.disabled = scrollLeft >= maxScroll - 1;
                }
            }

            if (prevButton) {
                prevButton.addEventListener('click', function () {
                    scrollToItem(-1);
                });
            }

            if (nextButton) {
                nextButton.addEventListener('click', function () {
                    scrollToItem(1);
                });
            }

            list.addEventListener('scroll', updateState, { passive: true });
            window.addEventListener('resize', updateState);

            updateState();
        });
    };
})();
